import PatientCareDoctorList from "../../components/screen/patientCare/patientCareDoctor/PatientCareDoctorList";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import HOC from "../../components/HOC";
import { theme } from "../../components/constants/muiTheme";
import { ThemeProvider } from "@mui/material";

const PatientCareDoctorDatabasePage = () => {
  return (
    <PageTemplate
      header="Doctor Database"
      mainComponent={
        <ThemeProvider theme={theme}>
          <PatientCareDoctorList />
        </ThemeProvider>
      }
      pageRole={21}
    />
  );
};

export default HOC(PatientCareDoctorDatabasePage);
